import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { SplashGate } from './components/common/SplashGate';
import RootErrorBoundary, { installGlobalErrorDiagnostics } from './components/common/RootErrorBoundary';
import reportWebVitals from './reportWebVitals';

const App = lazy(() => import('./App'));

installGlobalErrorDiagnostics();

const root = ReactDOM.createRoot(
  document.getElementById('app') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <SplashGate>
        <Suspense fallback={null}>
          <App />
        </Suspense>
      </SplashGate>
    </RootErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
